import React from "react";

import Text from "src/components/text";

import styles from "./sharesCard.module.scss";
import { User } from "src/types/users";
import { Analytics } from "src/types/reports";

const DefaultAssetIcon = "/images/defaultIcons/default_asset.jpg";

export interface SharesCardItem {
  user: User;
  analytics: Analytics;
}

export interface SharesCardProps {
  item: SharesCardItem;
}

export const SharesCard: React.FC<SharesCardProps> = ({ item }) => {
  const { user, analytics } = item;
  return (
    <div className={styles.card}>
      <img
        src={user.icon?.thumbnail || DefaultAssetIcon}
        className={`${styles.thumbnailIcon} ${styles.contactIcon}`}
        alt={`${user.firstName} ${user.lastName}`}
      />
      <div className={styles.content}>
        <Text
          lines={1}
          className={styles.title}
          text={`${user.firstName} ${user.lastName}`}
        />
        <div className={styles.metrics}>
          <span>{analytics.shares || 0} Shares</span>
          <span>{analytics.assets || 0} Assets</span>
          <span>{analytics.recipients || 0} Recipients</span>
        </div>
        <div className={styles.meta}>
          {user.lastActivityDate && (
            <>
              Last Active on:{" "}
              {new Date(user.lastActivityDate).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })}
            </>
          )}
        </div>
      </div>
    </div>
  );
};
